import { createContext, type ReactNode, useContext } from "react";
import { useChannels } from "@/hooks/useChannels";

type ChannelsContextValue = ReturnType<typeof useChannels>;

const ChannelsContext = createContext<ChannelsContextValue | null>(null);

export function ChannelsProvider({ children }: { children: ReactNode }) {
  const value = useChannels();
  return <ChannelsContext.Provider value={value}>{children}</ChannelsContext.Provider>;
}

/**
 * Read shared channels state from the nearest ChannelsProvider.
 * Throws if used outside the provider — this is intentional: the provider
 * is mounted at ProtectedShell so any authenticated page can use it.
 * Returns the full useChannels surface (channels list + mutation methods).
 */
export function useSharedChannels(): ChannelsContextValue {
  const ctx = useContext(ChannelsContext);
  if (!ctx) throw new Error("useSharedChannels must be used inside ChannelsProvider");
  return ctx;
}
